import { experimentEnabled } from '../adapters/experimentEnabled';
import { CONTEXT_PROPS } from '../types/ContextProps';
import { isMultilingualType } from '../types/MultilingualTypes';
import { get, getRawValue } from './get';
import { sanitizeUrl } from './sanitize-url';
var getPrimaryLanguage = function (languages) {
    if (languages === void 0) { languages = []; }
    return languages.filter(function (lang) { return lang.isPrimaryLanguage; });
};
export var getItemTypeDefaultUrl = function (itemType, item, fallback) {
    if (fallback === void 0) { fallback = ''; }
    if (!experimentEnabled('specs.seo.UseMultilingualFilter', getRawValue(item, 'context'))) {
        return fallback;
    }
    if (!isMultilingualType(itemType)) {
        var primaryLanguage = getPrimaryLanguage(getRawValue(item, "context." + CONTEXT_PROPS.SITE_LANGUAGES));
        return (primaryLanguage === null || primaryLanguage === void 0 ? void 0 : primaryLanguage.url) || fallback;
    }
    return (sanitizeUrl(get(item, "context." + CONTEXT_PROPS.DEFAULT_URL)) || fallback);
};
